"use client";
import { useState } from "react";
import { ContactPageQueryResult } from "@/sanity.types";

import BadgeRoundedSquare from "../../../utils/badge-rounded-square/BadgeRoundedSquare";
import { getIconForSocialMedia } from "@/app/(site)/_lib/helpers";

type InfoSocialMediaProps = {
	socialMediaList: NonNullable<ContactPageQueryResult>["content"]["socialMediaList"]["socialMediaListOrder"];
};

export default function InfoSocialMedia({ socialMediaList }: InfoSocialMediaProps) {
	const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

	const currentIcon =
		hoveredIndex !== null
			? getIconForSocialMedia(socialMediaList[hoveredIndex].name)
			: getIconForSocialMedia(socialMediaList[0]?.name || "");

	return (
		<div className="flex items-center gap-x-3">
			<BadgeRoundedSquare
				icon={currentIcon}
				backgroundColor="bg-navy-blue-light"
				iconColor="text-navy-blue-deep"
				className="h-[1.875rem] w-[1.875rem] shrink-0 transition-all duration-300 sm:h-[2.625rem] sm:w-[2.625rem]"
			/>
			<div className="flex flex-wrap items-center">
				{socialMediaList.map((socialMedia, index) => (
					<div key={socialMedia._id} className="flex items-center">
						<a
							href={socialMedia.link}
							target="_blank"
							rel="noopener noreferrer"
							className="text-body-m text-brown-middle hover:text-navy-blue-deep underline transition-colors duration-300"
							onMouseEnter={() => setHoveredIndex(index)}
							onMouseLeave={() => setHoveredIndex(null)}
						>
							{socialMedia.name}
						</a>
						{index < socialMediaList.length - 1 && <span className="text-body-m text-brown-middle mx-2">/</span>}
					</div>
				))}
			</div>
		</div>
	);
}
